// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const query = gql`
  mutation LOTE_ELIMINAR($id: ID!) {
    loteEliminar(id: $id)
  }
`

/**
 * API REST para la eliminación de un lote
 * @param id
 */
export const apiLoteEliminar = async (id: string): Promise<boolean> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { id })
    return data.loteEliminar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
